import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import { BASE_URL } from "../../component/config/web.config";
import { deleteSuccess } from "../slices/homeSlice";


//Get Presentation
export const actionGetAllPresentation = createAsyncThunk('actionGetAllPresentation', async () => {
    try {
        const res = await axios.get(`${BASE_URL}/presentation`);
        const { status, message: customMsg } = res.data;
        if (parseInt(status) === 200) {
            return res.data;
        } else if (parseInt(status) === 404) {
            return [];
        } else {
            message.error(customMsg, 5);
        }
    } catch (error) {
        message.error(error?.message, 5);
    }
})

//Create Presentation
export const actionCreatePresentation = createAsyncThunk('actionCreatePresentation', async (data) => {
    const { request, navigate, setActiveButton, setFileList } = data;
    try {
        const res = await axios.post(`${BASE_URL}/presentation`, request);
        const { status, message: customMsg, data } = res.data;
        if (parseInt(status) === 200) {
            message.success(customMsg, 5);
            setActiveButton('AllFiles')
            setFileList([])
            return data;
        } else {
            message.error(customMsg, 5);
        }
    } catch (error) {
        message.error(error?.message, 5);
    }

})

// Delete Presentation
export const actionDeletePresentation = createAsyncThunk('actionDeletePresentation', async (id, { dispatch }) => {
    try {
        const res = await axios.delete(`${BASE_URL}/presentation/${id}`);
        const { status, message: customMsg } = res.data;
        if (parseInt(status) === 200) {
            message.success(customMsg, 5);
            dispatch(deleteSuccess())
            return id;
        } else {
            message.error(customMsg, 5);
        }
    } catch (error) {
        message.error(error?.message, 5);
    }
})